import {
  SET_LOADER_SECONDARY,
  SET_LOADER,
  CLEAR_LOADER,
  SET_CURRENT_USER,
  SET_CURRENT_USER_DECODED_TOKEN,
  SET_STATUS,
  LOG_OUT,
  SET_FORGOT_MOBILE,
  NOTIFICATION_COUNT,
  SET_MENU_LOADER,
  CLEAR_MENU_LOADER,
} from "../types";
import isEmpty from "../validation/is-Empty";

const initialState = {
  loader: false,
  secondary_loader: false,
  user: {},
  decodedToken: {},
  isAuthenticated: false,
  status: 200,
  forgotNumber: "",
  notificationsCount: {},
  menu_loader: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_FORGOT_MOBILE:
      return {
        ...state,
        forgotNumber: action.payload,
      };
    case SET_LOADER_SECONDARY:
      return {
        ...state,
        secondary_loader: true,
      };
    case SET_LOADER:
      return {
        ...state,
        loader: true,
      };
    case SET_MENU_LOADER:
      return {
        ...state,
        menu_loader: true,
      };
    case CLEAR_LOADER:
      return {
        ...state,
        loader: false,
        secondary_loader: false,
      };
    case CLEAR_MENU_LOADER:
      return {
        ...state,
        menu_loader: false,
      };
    case SET_CURRENT_USER: {
      return {
        ...state,
        user: action.payload,
        isAuthenticated: !isEmpty(action.payload),
      };
    }
    case SET_CURRENT_USER_DECODED_TOKEN: {
      return {
        ...state,
        decodedToken: action.payload,
      };
    }
    case SET_STATUS: {
      return {
        ...state,
        status: action.payload,
      };
    }
    case NOTIFICATION_COUNT: {
      return {
        ...state,
        notificationsCount: action.payload,
      };
    }
    case LOG_OUT: {
      return {
        ...state,
        isAuthenticated: false,
        user: {},
        decodedToken: {},
      };
    }

    default:
      return state;
  }
}

// auth reduce
